const mobileResolution = 768;
const desktopResolution = 950;

export function isMobile() {
    return window.innerWidth <= mobileResolution;
}

export function isDesktop() {
    return window.innerWidth >= desktopResolution;
}